import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { Business, Email, Phone, LocationOn } from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { WorkpointSectionProps } from "../../Utils/Types";
import styles from "../../Styles/clientAccount.module.css";

export default function WorkpointSection({ workpoint }: WorkpointSectionProps) {
  return (
    <Card
      className={styles.infoCard}
      elevation={2}
      style={{ marginBottom: "16px" }}
    >
      <CardContent style={{ padding: "16px" }}>
        <Typography
          variant="h6"
          className={styles.sectionTitle}
          style={{ marginBottom: "12px" }}
        >
          <Business className={styles.sectionIcon} />
          {Vocabulary.workpointInformation}
        </Typography>
        {workpoint ? (
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Box className={styles.workpointItem}>
                <Business className={styles.workpointIcon} />
                <Typography variant="body2" className={styles.workpointValue}>
                  {workpoint.name}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className={styles.workpointItem}>
                <Phone className={styles.workpointIcon} />
                <Typography variant="body2" className={styles.workpointValue}>
                  {workpoint.phone}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className={styles.workpointItem}>
                <Email className={styles.workpointIcon} />
                <Typography variant="body2" className={styles.workpointValue}>
                  {workpoint.email}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box className={styles.workpointItem}>
                <LocationOn className={styles.workpointIcon} />
                <Typography variant="body2" className={styles.workpointValue}>
                  {workpoint.address
                    ? `${workpoint.address.city}, ${workpoint.address.country}`
                    : "Adresa nu este disponibilă"}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        ) : (
          <Typography
            variant="body2"
            style={{ textAlign: "center", padding: "8px", color: "#2e3a59" }}
          >
            Nu sunt informații disponibile despre sediu.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
